import { createSelector } from 'reselect';
import { VersionGamePresenter } from '@Selectors/common/VersionGamePresenter';
import { ArmyGamePresenter } from '@Selectors/common/ArmyGamePresenter';
import {
  getArmiesLoading,
  getArmyListLoading,
  getVersionsLoading,
} from '@Selectors/builder/myArmyList/common/selector';
import { BookNewView } from './view/book-new.view';

export const BookNewPresenter = createSelector(
  [
    VersionGamePresenter,
    ArmyGamePresenter,
    getVersionsLoading,
    getArmiesLoading,
    getArmyListLoading,
  ],
  (
    versions,
    armies,
    versionsIsLoading,
    armiesIsLoading,
    armyListLoading,
  ): BookNewView => {
    return new BookNewView({
      versions: versions,
      armies: armies,
      isLoading:
        versions.length === 0 ||
        armies.length === 0 ||
        versionsIsLoading ||
        armiesIsLoading ||
        armyListLoading,
      canSubmit: !(
        versions.length === 0 ||
        armies.length === 0 ||
        versionsIsLoading ||
        armiesIsLoading ||
        armyListLoading
      ),
    });
  },
);
